export default __webpack_public_path__ + "static/media/sign_up_middle_up3.15b0549d.png";